import { AfterViewInit, Component, ElementRef, Input, ViewEncapsulation } from "@angular/core";
import { Constant } from "../../constant";

@Component({
    selector: 'app-signed-contract',
    templateUrl: './signed-contract.component.html',
    styleUrls: ['./signed-contract.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SignedContractComponent implements AfterViewInit {
 
    @Input() documentId: string | null = null;
    @Input() signatoryId: string | null = null;
    @Input() isAdvance: boolean = true;
    
    public loading: boolean = true;

    private script = 'https://widget-test.weetrust.com.mx';
    private loadedScript = false;

    constructor(
        private readonly elementRef: ElementRef,
        private readonly constant: Constant
    ) {
        this.script = constant.script_weetrust;
        
        this.loadScript().then((response) => {
            setTimeout(() => {
                this.signed();
            }, 500);
        }).catch((err) => {
            console.log(err);
        });
    }

    ngAfterViewInit(): void {}

    private loadScript(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.loadedScript) {
                resolve({ loaded: true, status: 'Already Loaded'});
            } else {
                const script = document.createElement('script');
                script.id = 'script-weetrust';
                script.type = 'text/javascript';
                script.src = this.script;
                script.onload = () => {
                    this.loadedScript = true;
                    resolve({ loaded: true, status: 'Loaded'});
                };

                script.onerror = (err: any) => {
                    resolve({ loaded: true, status: 'Already Loaded', err });
                }

                this.elementRef.nativeElement.appendChild(script);
            }
        });
    }

    private signed(): void {
        const script = document.createElement('script');
        let url = 'advances/signed';

        if (!this.isAdvance) {
            url = 'rental-process/signed';
        }

        script.text = `
            var config = {
                documentID: '${this.documentId}',
                signatoryID: '${this.signatoryId}',
                apikey: '${this.constant.apiKeyWeetrust}',
                color: '#382bd8',
                onDocumentLoaded: () => {},
                onDocumentSigned: () => {
                    var token = localStorage.getItem('token');
                    var url = '${this.constant.api}${url}';
                    var xhr = new XMLHttpRequest();
                    xhr.open('PUT', url);
                    xhr.setRequestHeader('Content-Type', 'application/json');
                    xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                    xhr.onreadystatechange = function() {
                        setTimeout(function() { window.close(); }, 1000);
                    };

                    var data = {documentId: '${this.documentId}', signatoryId: '${this.signatoryId}'};

                    xhr.send(JSON.stringify(data));
                },
                onError: () => {
                    console.log('script error');
                }
            };

            Weesign.init('weesign-content', config);
        `;

        this.elementRef.nativeElement.appendChild(script);
    }

}